import React from 'react';

import fromAnyToString from 'utils/converters/fromAnyToString';
import nullBind from 'utils/functions/nullBind.util';

// SEE: https://reactjs.org/docs/forwarding-refs.html
// SEE: https://beta.reactjs.org/apis/react/forwardRef

const IndexedInput = React.forwardRef(({ index, onBlur, onChange, onKeyDown, inputMode, ...extra }, ref) => (
  <input
    {...extra}
    data-bem={`IndexedInput--${fromAnyToString(index)}`}
    onChange={nullBind(onChange, index)}
    onBlur={nullBind(onBlur, index)}
    onKeyDown={nullBind(onKeyDown, index)}
    ref={ref}
    inputMode={inputMode}
  />
));

// noinspection JSUnusedGlobalSymbols
export default IndexedInput;
